import React from "react";
import { motion } from "framer-motion";
import { useGenesis } from "@/hooks/useGenesis";
import { GenesisToken } from "@/components/genesis/GenesisToken";
import { StatusChip, Countdown, ExploreButton, BuyButton, RiskNote } from "@/components/genesis/GenesisBits";

// One compact card on the landing page. Hidden automatically once the sale has ended.
export function GenesisLandingCard() {
  const { data, status, countdown } = useGenesis();
  if (!data || !data.show_landing_card) return null;
  const buy = data.purchase_link_enabled && status !== "ended";
  return (
    <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }} data-testid="genesis-landing-card"
      className="relative mt-14 flex max-w-2xl flex-col gap-4 overflow-hidden rounded-3xl border border-am-border bg-am-surface/70 p-5 backdrop-blur-xl sm:flex-row sm:items-center">
      <span className="absolute inset-x-0 top-0 h-px aura-gradient opacity-70" />
      <GenesisToken size={72} className="mx-auto shrink-0 sm:mx-0" />
      <div className="min-w-0 flex-1 text-center sm:text-left">
        <div className="flex flex-wrap items-center justify-center gap-2 sm:justify-start"><span className="font-display text-base font-extrabold tracking-wide text-white md:text-lg">AURAMAX GENESIS</span><StatusChip status={status} /></div>
        <p className="mt-1 text-sm text-am-text2">The next era of social media. Learn how the $AURAMAX Genesis offering works and where it officially takes place.</p>
        <div className="mt-2 flex justify-center sm:justify-start"><Countdown countdown={countdown} status={status} compact /></div>
        <div className="mt-3 flex flex-col items-center gap-2 sm:flex-row sm:items-center">
          <BuyButton data={data} status={status} size="md" testid="genesis-landing-buy" surface="landing" />
          <ExploreButton testid="genesis-landing-explore" secondary={buy} />
        </div>
        {buy && <RiskNote className="mt-2" />}
      </div>
    </motion.div>
  );
}
